function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);

    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

function subscribe(extra = {}) {
    return navigator.serviceWorker.ready
        .then((registration) => registration.pushManager.getSubscription()
            .then((existing) => existing || registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(window.AianCart.vapidPublicKey),
            })))
        .then((subscription) => fetch(route('push_subscriptions.store'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': window.AianCart.csrfToken,
            },
            body: JSON.stringify(Object.assign(subscription.toJSON(), extra)),
        }));
}

const PUSH_BAR_DISMISSED_KEY = 'push_notification_bar_dismissed';

function hidePushNotificationBar() {
    const bar = document.getElementById('pushNotificationBar');

    if (bar) {
        bar.style.display = 'none';
    }
}

function showPushNotificationBar() {
    if (Notification.permission !== 'default') {
        return;
    }

    try {
        if (localStorage.getItem(PUSH_BAR_DISMISSED_KEY)) {
            return;
        }
    } catch (e) {
        // localStorage unavailable, fall through and show the bar
    }

    navigator.serviceWorker.ready
        .then((registration) => registration.pushManager.getSubscription())
        .then((existing) => {
            if (existing) {
                return;
            }

            const bar = document.getElementById('pushNotificationBar');

            if (bar) {
                bar.style.display = '';
            }
        });
}

if ('serviceWorker' in navigator && 'PushManager' in window && window.AianCart.vapidPublicKey) {
    navigator.serviceWorker.register('/service-worker.js');

    window.AianCartPush = { subscribe };

    document.addEventListener('DOMContentLoaded', () => {
        showPushNotificationBar();

        const closeButton = document.getElementById('pushNotificationBarClose');

        if (closeButton) {
            closeButton.addEventListener('click', () => {
                hidePushNotificationBar();

                try {
                    localStorage.setItem(PUSH_BAR_DISMISSED_KEY, '1');
                } catch (e) {
                    // ignore if localStorage is unavailable
                }
            });
        }

        document.querySelectorAll('[data-push-subscribe]').forEach((button) => {
            button.addEventListener('click', () => {
                const originalText = button.textContent;
                const extra = {
                    order_id: button.dataset.orderId || null,
                    email: button.dataset.email || null,
                };

                button.disabled = true;

                Notification.requestPermission()
                    .then((permission) => {
                        if (permission !== 'granted') {
                            throw new Error('permission_denied');
                        }

                        return subscribe(extra);
                    })
                    .then(() => {
                        button.textContent = button.dataset.subscribedText || 'Notifications enabled';
                        hidePushNotificationBar();
                    })
                    .catch(() => {
                        button.disabled = false;
                        button.textContent = originalText;
                    });
            });
        });
    });
}
